import {Popover} from 'bootstrap';
import openEditorClickEvent from './_open-editor-click-event';
import {isTouchDevice} from "./_globals";

export default function() {
    const $popovers = $('[data-bs-toggle="popover"]');
    $.each($popovers, function () {
        $(this).data('state', 'hover');
        let triggerMode = $(this).data('trigger');
        // Pinnable popovers, see http://stackoverflow.com/a/18754902/94289
        // Use pinnable popovers per default if no other trigger mode is specified and if the element is no link
        const isLink = $(this).attr('href') !== undefined || $(this).attr('type') === 'submit';
        const hasOtherTriggerMode = triggerMode !== undefined;
        const isPinnablePopover = !hasOtherTriggerMode && !isLink && !isTouchDevice();
        if (isPinnablePopover) {
            triggerMode = 'manual';
        } else if (isLink) {
            triggerMode = 'hover';
        } else if (isTouchDevice()) {
            triggerMode = 'click';
        }
        const popover = new Popover(this, {
            delay: 200,
            trigger: triggerMode,
            html: true,
            container: 'body' // Prevents chopping off as of tb 2.3.0
        });
        if (isPinnablePopover) {
            $(this).on('mouseenter', function () {
                if ($(this).data('state') === 'hover') {
                    popover.show();
                }
            }).on('mouseleave', function () {
                if ($(this).data('state') === 'hover') {
                    popover.hide();
                }
            }).on('click', function (e) {
                if ($(this).data('state') === 'hover') {
                    $(this).data('state', 'pinned');
                    popover.show();
                    openEditorClickEvent();
                    e.preventDefault();
                } else {
                    popover.hide();
                }
            });
        }
    });

    // Hide popover on click-/touch-events outside the popover-element (needed for pinned popover).
    // See https://stackoverflow.com/a/14857326.
    $('body').on('click touchstart', function (e) {
        const targetElement = $(e.target);
        if (targetElement.data('bs-toggle') !== 'popover'
            && targetElement.parents('[data-bs-toggle="popover"]').length === 0
            && targetElement.parents('.popover.show').length === 0) {
            const $popovers = $('[data-bs-toggle="popover"]');
            $.each($popovers, function () {
                $(this).data('state', 'hover');
                const popover = Popover.getInstance(this);
                if (popover) {
                    popover.hide();
                }
            });
        }
    });
}
